import React, { useState, useEffect } from 'react';
import './ManagerClients.css';

const ManagerClients = () => {
  // ==================== STATE MANAGEMENT ====================
  const [clients, setClients] = useState([
    {
      id: 1,
      clientNo: 'CLT-001',
      company: 'Acme Industries',
      contactPerson: 'Rohit Sharma',
      email: 'rohit@acme.in',
      phone: '+91 98200 11122',
      linkedEnquiry: 'ENQ-X1Y2Z',
      pos: 1,
      owner: 'Priya (Exec)',
      onboarded: '2025-04-20',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-20',
      toDate: '2026-04-19',
      website: 'https://www.acmeindustries.com',
      agreementDoc: 'agreement_acme.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-19',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0,
      contractValue: '₹12,00,000',
      paymentTerms: 'Net 30',
      assignedManager: 'Aarav (Manager)'
    },
    {
      id: 2,
      clientNo: 'CLT-002',
      company: 'Nimbus Tech',
      contactPerson: 'Anita Desai',
      email: 'anita@nimbus.io',
      phone: '+91 98300 22333',
      linkedEnquiry: 'ENQ-P9Q3R',
      pos: 2,
      owner: 'Karan (Exec)',
      onboarded: '2025-04-18',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-18',
      toDate: '2026-04-17',
      website: 'https://www.nimbustech.io',
      agreementDoc: 'agreement_nimbus.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-17',
      poGenerated: true,
      lastPONumber: 'PO-2025-001',
      renewalSentCount: 1,
      contractValue: '₹8,50,000',
      paymentTerms: 'Net 45',
      assignedManager: 'Neha (Manager)'
    },
    {
      id: 3,
      clientNo: 'CLT-003',
      company: 'Orbit Logistics',
      contactPerson: 'Vikram Mehta',
      email: 'vikram@orbit.co',
      phone: '+91 98400 33444',
      linkedEnquiry: 'ENQ-R7S8T',
      pos: 3,
      owner: 'Priya (Exec)',
      onboarded: '2025-04-15',
      status: 'Active',
      source: 'Manual Add',
      fromDate: '2025-04-15',
      toDate: '2026-04-14',
      website: 'https://www.orbitlogistics.co',
      agreementDoc: 'agreement_orbit.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-14',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0,
      contractValue: '₹24,00,000',
      paymentTerms: 'Net 60',
      assignedManager: 'Aarav (Manager)'
    },
    {
      id: 4,
      clientNo: 'CLT-004',
      company: 'BluePeak Foods',
      contactPerson: 'Sara Khan',
      email: 'sara@bluepeak.in',
      phone: '+91 98500 44555',
      linkedEnquiry: 'ENQ-U5V6W',
      pos: 4,
      owner: 'Karan (Exec)',
      onboarded: '2025-04-10',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-10',
      toDate: '2026-04-09',
      website: 'https://www.bluepeak.in',
      agreementDoc: 'agreement_bluepeak.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-09',
      poGenerated: true,
      lastPONumber: 'PO-2025-089',
      renewalSentCount: 0,
      contractValue: '₹5,75,000',
      paymentTerms: 'Net 30',
      assignedManager: 'Neha (Manager)'
    }
  ]);

  // Auto-load from localStorage
  useEffect(() => {
    const savedClients = localStorage.getItem('clientsData');
    if (savedClients) {
      const parsed = JSON.parse(savedClients);
      if (parsed.length > 0) {
        // Merge with extra manager fields
        const merged = parsed.map(c => ({
          ...c,
          contractValue: c.contractValue || '—',
          paymentTerms: c.paymentTerms || 'Standard',
          assignedManager: c.assignedManager || 'Unassigned'
        }));
        setClients(merged);
      }
    }

    // Listen for new clients from Sales Quotation
    const handleNewClient = (event) => {
      if (event.data && event.data.type === 'NEW_CLIENT_GENERATED') {
        const newClientData = event.data.client;
        const exists = clients.some(c => c.clientNo === newClientData.id);
        if (!exists) {
          const newClient = {
            id: clients.length + 1,
            clientNo: newClientData.id,
            company: newClientData.name,
            contactPerson: newClientData.name,
            email: newClientData.email,
            phone: newClientData.phone,
            linkedEnquiry: newClientData.enquiryNo,
            pos: clients.length + 1,
            owner: newClientData.generatedBy,
            onboarded: newClientData.generatedDate,
            status: 'Active',
            source: 'Auto Generated',
            fromDate: newClientData.generatedDate,
            toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            website: '',
            agreementDoc: '',
            lastRenewalDate: null,
            nextRenewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            poGenerated: false,
            lastPONumber: null,
            renewalSentCount: 0,
            contractValue: '—',
            paymentTerms: 'Standard',
            assignedManager: 'Aarav (Manager)'
          };
          setClients(prev => {
            const updated = [...prev, newClient];
            localStorage.setItem('clientsData', JSON.stringify(updated));
            return updated;
          });
          alert(`✅ New client "${newClient.company}" auto-added from quotation!`);
        }
      }
    };

    window.addEventListener('message', handleNewClient);
    const pending = localStorage.getItem('pendingClientData');
    if (pending) {
      const data = JSON.parse(pending);
      const exists = clients.some(c => c.clientNo === data.id);
      if (!exists) {
        const newC = {
          id: clients.length + 1,
          clientNo: data.id,
          company: data.name,
          contactPerson: data.name,
          email: data.email,
          phone: data.phone,
          linkedEnquiry: data.enquiryNo,
          pos: clients.length + 1,
          owner: data.generatedBy,
          onboarded: data.generatedDate,
          status: 'Active',
          source: 'Auto Generated',
          fromDate: data.generatedDate,
          toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          website: '',
          agreementDoc: '',
          lastRenewalDate: null,
          nextRenewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          poGenerated: false,
          lastPONumber: null,
          renewalSentCount: 0,
          contractValue: '—',
          paymentTerms: 'Standard',
          assignedManager: 'Aarav (Manager)'
        };
        setClients(prev => {
          const upd = [...prev, newC];
          localStorage.setItem('clientsData', JSON.stringify(upd));
          return upd;
        });
        localStorage.removeItem('pendingClientData');
        alert(`✅ New client "${newC.company}" auto-added!`);
      }
    }
    return () => window.removeEventListener('message', handleNewClient);
  }, []);

  // Modals visibility
  const [mgrShowViewModal, setMgrShowViewModal] = useState(false);
  const [mgrShowEditModal, setMgrShowEditModal] = useState(false);
  const [mgrShowApproveModal, setMgrShowApproveModal] = useState(false);
  const [mgrSelectedClient, setMgrSelectedClient] = useState(null);
  
  // Manager approval / remarks
  const [mgrApprovalRemark, setMgrApprovalRemark] = useState('');
  
  // Edit form state
  const [mgrEditForm, setMgrEditForm] = useState({
    company: '',
    contactPerson: '',
    email: '',
    phone: '',
    contractValue: '',
    paymentTerms: '',
    assignedManager: '',
    status: 'Active',
    website: ''
  });

  // Stats for manager dashboard
  const totalClients = clients.length;
  const activeClients = clients.filter(c => c.status === 'Active').length;
  const poGeneratedCount = clients.filter(c => c.poGenerated).length;
  const renewalsPending = clients.filter(c => {
    if (!c.toDate) return false;
    const daysLeft = Math.ceil((new Date(c.toDate) - new Date()) / (1000*60*60*24));
    return daysLeft <= 30 && daysLeft > 0;
  }).length;

  const mgrManagerOptions = ['Aarav (Manager)', 'Neha (Manager)', 'Priya (Exec)', 'Karan (Exec)', 'Unassigned'];
  const mgrPaymentTermsOptions = ['Net 30', 'Net 45', 'Net 60', 'Advance', 'Standard'];

  // Helper functions
  const mgrFormatDate = (dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB');
  };

  const mgrIsRenewalNeeded = (toDate) => {
    if (!toDate) return false;
    const today = new Date();
    const end = new Date(toDate);
    const days = Math.ceil((end - today) / (1000*60*60*24));
    return days <= 30 && days > 0;
  };

  const mgrHandleView = (client) => {
    setMgrSelectedClient(client);
    setMgrShowViewModal(true);
  };

  const mgrHandleEdit = (client) => {
    setMgrSelectedClient(client);
    setMgrEditForm({
      company: client.company,
      contactPerson: client.contactPerson,
      email: client.email,
      phone: client.phone,
      contractValue: client.contractValue || '—',
      paymentTerms: client.paymentTerms || 'Standard',
      assignedManager: client.assignedManager || 'Unassigned',
      status: client.status,
      website: client.website || ''
    });
    setMgrShowEditModal(true);
  };

  const mgrSaveEdit = () => {
    if (!mgrSelectedClient) return;
    const updated = clients.map(c => {
      if (c.id === mgrSelectedClient.id) {
        return {
          ...c,
          company: mgrEditForm.company,
          contactPerson: mgrEditForm.contactPerson,
          email: mgrEditForm.email,
          phone: mgrEditForm.phone,
          contractValue: mgrEditForm.contractValue,
          paymentTerms: mgrEditForm.paymentTerms,
          assignedManager: mgrEditForm.assignedManager,
          status: mgrEditForm.status,
          website: mgrEditForm.website
        };
      }
      return c;
    });
    setClients(updated);
    localStorage.setItem('clientsData', JSON.stringify(updated));
    setMgrShowEditModal(false);
    alert(`✅ Client ${mgrEditForm.company} updated successfully!`);
  };

  const mgrHandleApprove = (client) => {
    setMgrSelectedClient(client);
    setMgrApprovalRemark('');
    setMgrShowApproveModal(true);
  };

  const mgrSubmitApproval = () => {
    if (!mgrSelectedClient) return;
    const updated = clients.map(c => {
      if (c.id === mgrSelectedClient.id) {
        return {
          ...c,
          status: 'Active',
          approvalRemark: mgrApprovalRemark || 'Approved by Manager',
          approvalDate: new Date().toISOString().split('T')[0]
        };
      }
      return c;
    });
    setClients(updated);
    localStorage.setItem('clientsData', JSON.stringify(updated));
    setMgrShowApproveModal(false);
    alert(`✅ Client ${mgrSelectedClient.company} has been approved.`);
  };

  const mgrSendReminder = (client) => {
    alert(`📧 Renewal reminder sent to ${client.email} for contract ending on ${mgrFormatDate(client.toDate)}`);
  };

  return (
    <div className="mgr-container">
      <div className="mgr-wrapper">
    
        <div className="mgr-table-wrapper">
          <div className="mgr-table-header">
            <h3>📌 Client Master List</h3>
            <div className="mgr-table-actions">
              <button className="mgr-refresh-btn" onClick={() => {
                const saved = localStorage.getItem('clientsData');
                if(saved) setClients(JSON.parse(saved));
                alert("Data refreshed");
              }}>⟳ Refresh</button>
            </div>
          </div>
          <div className="mgr-table-responsive">
            <table className="mgr-table">
              <thead>
                <tr>
                  <th>Client #</th>
                  <th>Company</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Contract Value</th>
                  <th>Valid Till</th>
                  <th>PO Status</th>
                  <th>Manager</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {clients.map(client => (
                  <tr key={client.id} className={mgrIsRenewalNeeded(client.toDate) ? 'mgr-row-warning' : ''}>
                    <td className="mgr-client-no">{client.clientNo}</td>
                    <td className="mgr-company">{client.company}</td>
                    <td>{client.contactPerson}</td>
                    <td className="mgr-email">{client.email}</td>
                    <td className="mgr-value">{client.contractValue }</td>
                    <td className={mgrIsRenewalNeeded(client.toDate) ? 'mgr-expiring' : ''}>
                      {mgrFormatDate(client.toDate)}
                      {mgrIsRenewalNeeded(client.toDate) && <span className="mgr-warning-badge">⚠️</span>}
                    </td>
                    <td>
                      {client.poGenerated ? 
                        <span className="mgr-badge-po">✅ {client.lastPONumber}</span> : 
                        <span className="mgr-badge-pending">Pending</span>
                      }
                    </td>
                    <td>{client.assignedManager || '—'}</td>
                    <td>
                      <span className={`mgr-status ${client.status === 'Active' ? 'mgr-status-active' : 'mgr-status-inactive'}`}>
                        {client.status}
                      </span>
                    </td>
                    <td>
                      <div className="mgr-action-group">
                        <button className="mgr-btn-view" onClick={() => mgrHandleView(client)}>👁️ View</button>
                        <button className="mgr-btn-edit" onClick={() => mgrHandleEdit(client)}>✏️ Edit</button>
                        {client.status !== 'Active' && (
                          <button className="mgr-btn-approve" onClick={() => mgrHandleApprove(client)}>✔️ Approve</button>
                        )}
                        <button className="mgr-btn-reminder" onClick={() => mgrSendReminder(client)}>📧 Remind</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ========== VIEW CLIENT MODAL ========== */}
      {mgrShowViewModal && mgrSelectedClient && (
        <div className="mgr-modal-overlay" onClick={() => setMgrShowViewModal(false)}>
          <div className="mgr-modal mgr-modal-view" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>📄 Client Details – {mgrSelectedClient.clientNo}</h3>
              <button className="mgr-modal-close" onClick={() => setMgrShowViewModal(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-detail-grid">
                <div className="mgr-detail-row"><span className="mgr-detail-label">Company:</span><span>{mgrSelectedClient.company}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Contact:</span><span>{mgrSelectedClient.contactPerson}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Email:</span><span>{mgrSelectedClient.email}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Phone:</span><span>{mgrSelectedClient.phone}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Website:</span><span>{mgrSelectedClient.website || '—'}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Contract Value:</span><span className="mgr-highlight">{mgrSelectedClient.contractValue || '—'}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Payment Terms:</span><span>{mgrSelectedClient.paymentTerms || '—'}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Valid From:</span><span>{mgrFormatDate(mgrSelectedClient.fromDate)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Valid To:</span><span>{mgrFormatDate(mgrSelectedClient.toDate)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Next Renewal:</span><span>{mgrFormatDate(mgrSelectedClient.nextRenewalDate)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">PO Generated:</span><span>{mgrSelectedClient.poGenerated ? `Yes (${mgrSelectedClient.lastPONumber})` : 'No'}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Assigned Manager:</span><span>{mgrSelectedClient.assignedManager}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Status:</span><span className="mgr-status-badge">{mgrSelectedClient.status}</span></div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-btn-secondary" onClick={() => setMgrShowViewModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ========== EDIT CLIENT MODAL ========== */}
      {mgrShowEditModal && mgrSelectedClient && (
        <div className="mgr-modal-overlay" onClick={() => setMgrShowEditModal(false)}>
          <div className="mgr-modal mgr-modal-edit" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>✏️ Edit Client – {mgrSelectedClient.company}</h3>
              <button className="mgr-modal-close" onClick={() => setMgrShowEditModal(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-form-group">
                <label>Company Name *</label>
                <input type="text" value={mgrEditForm.company} onChange={(e) => setMgrEditForm({...mgrEditForm, company: e.target.value})} />
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group"><label>Contact Person</label><input type="text" value={mgrEditForm.contactPerson} onChange={(e) => setMgrEditForm({...mgrEditForm, contactPerson: e.target.value})} /></div>
                <div className="mgr-form-group"><label>Email</label><input type="email" value={mgrEditForm.email} onChange={(e) => setMgrEditForm({...mgrEditForm, email: e.target.value})} /></div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group"><label>Phone</label><input type="text" value={mgrEditForm.phone} onChange={(e) => setMgrEditForm({...mgrEditForm, phone: e.target.value})} /></div>
                <div className="mgr-form-group"><label>Website</label><input type="text" value={mgrEditForm.website} onChange={(e) => setMgrEditForm({...mgrEditForm, website: e.target.value})} /></div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group"><label>Contract Value</label><input type="text" value={mgrEditForm.contractValue} onChange={(e) => setMgrEditForm({...mgrEditForm, contractValue: e.target.value})} placeholder="₹XX,XX,XXX" /></div>
                <div className="mgr-form-group"><label>Payment Terms</label>
                  <select value={mgrEditForm.paymentTerms} onChange={(e) => setMgrEditForm({...mgrEditForm, paymentTerms: e.target.value})}>
                    {mgrPaymentTermsOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group"><label>Assigned Manager</label>
                  <select value={mgrEditForm.assignedManager} onChange={(e) => setMgrEditForm({...mgrEditForm, assignedManager: e.target.value})}>
                    {mgrManagerOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                <div className="mgr-form-group"><label>Status</label>
                  <select value={mgrEditForm.status} onChange={(e) => setMgrEditForm({...mgrEditForm, status: e.target.value})}>
                    <option value="Active">Active</option>
                    <option value="Pending Approval">Pending Approval</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-btn-cancel" onClick={() => setMgrShowEditModal(false)}>Cancel</button>
              <button className="mgr-btn-save" onClick={mgrSaveEdit}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* ========== APPROVE CLIENT MODAL ========== */}
      {mgrShowApproveModal && mgrSelectedClient && (
        <div className="mgr-modal-overlay" onClick={() => setMgrShowApproveModal(false)}>
          <div className="mgr-modal mgr-modal-approve" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>✔️ Approve Client Contract</h3>
              <button className="mgr-modal-close" onClick={() => setMgrShowApproveModal(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-info-card">
                <p><strong>Client:</strong> {mgrSelectedClient.company} ({mgrSelectedClient.clientNo})</p>
                <p><strong>Current Status:</strong> {mgrSelectedClient.status}</p>
                <p><strong>Contract Period:</strong> {mgrFormatDate(mgrSelectedClient.fromDate)} → {mgrFormatDate(mgrSelectedClient.toDate)}</p>
              </div>
              <div className="mgr-form-group">
                <label>Approval Remarks (Optional)</label>
                <textarea rows="3" placeholder="Add any notes or conditions..." value={mgrApprovalRemark} onChange={(e) => setMgrApprovalRemark(e.target.value)}></textarea>
              </div>
              <div className="mgr-warning-note">
                ⚡ Approving this client will mark the contract as "Active" and enable all features.
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-btn-cancel" onClick={() => setMgrShowApproveModal(false)}>Cancel</button>
              <button className="mgr-btn-approve-submit" onClick={mgrSubmitApproval}>Confirm Approval</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerClients;